<template>

</template>

<script>
export default {
  name: "Cash"
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Cash.vue